import WidgetMarketingPage from './WidgetMarketingPage';

export default WidgetMarketingPage;
